<template>
    <div>
        <div class="flex flex-column">
            <h1 class="header">Update method</h1>
            <v-text-field
                v-model="editMethodParams.name"
                label="Method Name"
                class="method_name_input"
            ></v-text-field>
            <v-text-field
                v-model="editMethodParams.minimum_payment_amount"
                label="Minimum Amount"
                type="number"
            ></v-text-field>
            <v-switch v-model="editMethodParams.tipalti" label="Tipalti"></v-switch>
            <v-row>
                <v-col cols="6">
                    <v-switch v-model="editMethodParams.is_on_dashboard_enabled" label="Dashboard Enabled"></v-switch>
                </v-col>
                <v-col cols="6">
                    <v-switch v-model="editMethodParams.is_on_funnel_enabled" label="Funnel Enabled"></v-switch>
                </v-col>
            </v-row>
            <div class="button-row">
                <v-btn
                    class="btn"
                    color="primary"
                    @click="updateMethod"
                    :disabled="!editMethodParamsValidation"
                    :class="{disabled_btn: !editMethodParamsValidation}"
                >
                    <span v-if="!loading">Update</span>
                    <v-progress-circular v-else class="progress-absolute" indeterminate color="white" size="25"></v-progress-circular>
                </v-btn>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  import store from "@/store";
  
  export default {
    props: {
      item: {
        type: Object
      }
    },
    async mounted() {
        this.editMethodParams = {...this.item.data};
        this.editMethodParams.is_on_dashboard_enabled = this.item.data.is_on_dashboard_enabled === 1;
        this.editMethodParams.is_on_funnel_enabled = this.item.data.is_on_funnel_enabled === 1;
        this.initialMethod = {...this.editMethodParams};
    },
    methods: {
        async updateMethod() {
            this.loading = true;
            console.log('dashboard', this.editMethodParams.is_on_dashboard_enabled);
            console.log('funnel', this.editMethodParams.is_on_funnel_enabled);
            
            await store.dispatch('payments/updateMethod', {
                    id: this.item.data.id,
                    name: this.editMethodParams.name,
                    minimum_amount: this.editMethodParams.minimum_payment_amount,
                    tipalti: this.editMethodParams.tipalti === 1 ? true : false,
                    is_on_dashboard_enabled: this.editMethodParams.is_on_dashboard_enabled,
                    is_on_funnel_enabled: this.editMethodParams.is_on_funnel_enabled,
            });
            
            this.loading = false;
        },
        compareObjects(obj1, obj2) {
            const keys1 = Object.keys(obj1);
            const keys2 = Object.keys(obj2);

            if (keys1.length !== keys2.length) {
                return false;
            }

            for (const key of keys1) {
                if (obj1[key] != obj2[key]) {
                return false;
                }
            }

            return true;
        }
    },
    computed: {
        editMethodParamsValidation() {
            return !this.compareObjects(this.editMethodParams, this.initialMethod);                    
        }
    },
    name: "MethodCard",
    data() {
      return {
        loading: false,
        editMethodParams: {
          name: '',
          minimum_payment_amount: '',
          tipalti: true,
        },
        initialMethod: {}
      }
    }
  }
  </script>
  
  <style scoped lang="sass">
    .flex-column 
        display: flex
        flex-direction: column
        padding: 20px 
    .header
        text-align: center
    .button-row 
        display: flex
        justify-content: space-between
  </style>
  